import api from './api';
export default {

    post: (masterProjects) => api.post('/api/processareas', { masterProjects }),

};